import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import useLocalStorage from 'hooks/useLocalStorage';
import { typedEntries } from 'utils/funcs';
import { isDeepEqual } from 'utils/objectUtils';
import { ObjectShape, TypeOfShape } from 'yup/lib/object';
import useFilterFormContext from './useFilterFormContext';

const useFilterFormContextApplyFiltersStoredValues = <
  T extends ObjectShape,
>() => {
  const {
    getValues: getCurrentFormValues,
    setValue,
    formState: { defaultValues },
  } = useFormContext<TypeOfShape<T>>();
  const { schema, filtersLocalStorageKey } = useFilterFormContext<T>();
  const { getValue: getStoredFilterFormValues } = useLocalStorage<T>(
    filtersLocalStorageKey,
  );

  useEffect(() => {
    const currentFormValues = getCurrentFormValues();
    const storedFormValues = getStoredFilterFormValues();

    if (!storedFormValues || !currentFormValues || !defaultValues) {
      return;
    }

    const storedValues = schema.cast(storedFormValues);

    typedEntries(storedValues)
      .filter(([key, value]) => !isDeepEqual(value, defaultValues[key]))
      .forEach(([key]) =>
        // @ts-expect-error
        setValue(key, storedValues[key], { shouldDirty: true }),
      );
  }, []);
};

export default useFilterFormContextApplyFiltersStoredValues;
